<template>
  <v-sheet :height="height" class="data-calendar-shell">
    <v-calendar
      ref="calendar"
      :value="value"
      :now="now"
      :locale="locale"
      :weekdays="weekdays"
      :type="type"
      :events="events"
      :event-overlap-threshold="eventOverlapThreshold"
      :event-color="eventColor"
      :color="color"
      :class="['data-calendar', calendarClass]"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @click:event="$emit('click:event', $event)"
      @click:date="$emit('click:date', $event)"
      @click:day="$emit('click:day', $event)" />
  </v-sheet>
</template>

<script>
export default {
  name: "DataCalendar",
  props: {
    value: { type: String, default: "" },
    now: { type: String, default: "" },
    events: { type: Array, default: () => [] },
    type: { type: String, default: "month" },
    locale: { type: String, default: "id" },
    weekdays: { type: Array, default: () => [0, 1, 2, 3, 4, 5, 6] },
    height: { type: [String, Number], default: 600 },
    eventOverlapThreshold: { type: Number, default: 30 },
    eventColor: { type: [String, Function], default: "primary" },
    color: { type: String, default: "primary" },
    calendarClass: { type: [String, Array, Object], default: "" },
  },
  computed: {
    title() {
      const calendarState = `${this.value}:${this.type}`
      return calendarState && this.$refs.calendar ? this.$refs.calendar.title : ""
    },
  },
  methods: {
    prev() {
      if (this.$refs.calendar) this.$refs.calendar.prev()
    },
    next() {
      if (this.$refs.calendar) this.$refs.calendar.next()
    },
    scrollToTime(time) {
      if (this.$refs.calendar && this.$refs.calendar.scrollToTime) {
        this.$refs.calendar.scrollToTime(time)
      }
    },
    checkChange() {
      if (this.$refs.calendar && this.$refs.calendar.checkChange) {
        this.$refs.calendar.checkChange()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.data-calendar-shell {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.data-calendar { height: 100%; }
</style>
